// Les liens partenaires passent par un pretty link WordPress : leur clic est tracké, pas suivi en navigation directe
export const isPartnerLink = (url: string): boolean => url.includes("/guide/partenaire")
